import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { filter, pluck, takeWhile } from 'rxjs/operators'
import { fromEvent } from 'rxjs'

import { faEllipsisVAlt } from '@fortawesome/pro-light-svg-icons'
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons'

import './TitleHolder.css'
import QbIcon from '../QbIcon/QbIcon'
import QbButton from '../QbButton/QbButton'
import { MENU_FUNCTIONS } from '../../../store/actions/menu'

class TitleHolder extends Component {

  state = {
    shouldCloseMenu: false
  }

  handleMenuClick = () => {
    const { shouldCloseMenu } = this.state

    if (shouldCloseMenu) {
      this.setState({
        shouldCloseMenu: !this.state.shouldCloseMenu
      }, () => {
        this.props.onMenuClick()
      })
    } else {
      this.props.onMenuClick()
    }
  }

  componentDidMount() {
    const { menu } = this.props

    if (menu.open) {
      this.props.closeMenu()
    }

    DocumentClick$.pipe(
      takeWhile(() => this.childNode),
      filter(_ => this.props.menu.open),
    ).subscribe(_ => {
      if (this.state.shouldCloseMenu) {
        this.props.closeMenu()
        this.setState({ shouldCloseMenu: false })
      } else {
        this.setState({ shouldCloseMenu: true })
      }
    })
  }

  render () {
    const { title, menu, onMenuMouseEnter, onMenuMouseLeave, showMenu } = this.props
    return (
      <div ref={node => this.childNode = node} className="title-holder-container">
        <div className="title-holder-sub-container">
          <QbIcon />
          <div className="title-holder-title">{title}</div>
          {
            showMenu ?
              <Menu
                menu={menu}
                onMenuClick={this.handleMenuClick}
                onMenuMouseEnter={onMenuMouseEnter}
                onMenuMouseLeave={onMenuMouseLeave}          
              />
              : null 
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ menuReducer }) => {
  return {
    menu: menuReducer
  }
}

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    ...MENU_FUNCTIONS
  }, dispatch)


export default connect(mapStateToProps, mapDispatchToProps)(TitleHolder)

const Menu = ({ menu, onMenuClick, onMenuMouseEnter, onMenuMouseLeave }) => (
  <div
    onMouseEnter={() => onMenuMouseEnter()}
    style={STYLE.MENU_CONTAINER}
    onMouseLeave={() => onMenuMouseLeave()}
  >
    <QbButton
      style={STYLE.BUTTON_STYLE} simple icon={menu.open || menu.hovering ? faEllipsisV : faEllipsisVAlt}
      iconStyle={STYLE.ICON_STYLE}
      onClick={onMenuClick}
    />
  </div>
)

const DocumentClick$ = fromEvent(document, 'click').pipe(
  pluck('target')
)

const STYLE = {
  MENU_CONTAINER: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row-reverse',
    height: '100%'
  },
  BUTTON_STYLE: {
    backgroundColor: 'transparent',
    height: '20px',
    alignSelf: 'center'
  },
  ICON_STYLE: {
    color: '#ffffff',
    height: '20px',
    width: '10px',
    fill: 'red'
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/TitleHolder/TitleHolder.js